import { WEB_CONFIG_SCHEMA } from './index';

export const webConfig = WEB_CONFIG_SCHEMA.parse(import.meta.env);
